import { clearIdentitySession } from "./authStorage";
const ACCOUNTS_API = process.env.REACT_APP_ACCOUNTS_API_URL || "https://api.accounts.clikkle.com/api";
export async function verifyChatIdentitySession() {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) return { status: "inactive", reason: "missing_refresh_token" };
  try {
    const response = await fetch(`${ACCOUNTS_API.replace(/\/$/, "")}/auth/session/status`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ refreshToken }) });
    const payload = await response.json().catch(() => ({}));
    if (!response.ok || payload?.active !== true) { clearIdentitySession(); return { status: "inactive", reason: payload?.code || "session_inactive" }; }
    return { status: "active", payload };
  } catch (error) { return { status: "unverifiable", reason: "accounts_unavailable", error }; }
}
